import { trackEvent } from './analytics';

export type UiEvent = 'main_button_click' | 'application_start' | 'booking_start' | 'ui_error';

const ERROR_CATEGORIES: Record<string, string> = {
  'Customer sign-in required': 'sign_in_required',
  'Missing Information': 'validation_failed',
  'Limit Reached': 'selection_limit',
  'Time Unavailable': 'time_unavailable',
  'Schedule Failed': 'booking_failed',
  'Upload Failed': 'upload_failed',
};

export const notificationErrorCategory = (message: string): string =>
  Object.prototype.hasOwnProperty.call(ERROR_CATEGORIES, message) ? ERROR_CATEGORIES[message] : 'displayed_error';

// Use route categories rather than URLs, which may contain personal data or tokens.
const PAGE_TYPES: Record<string, string> = {
  '': 'home',
  'chat-with-mimi': 'smart_search',
  search: 'smart_search',
  unit: 'unit',
  building: 'building',
  comparison: 'comparison',
  login: 'login',
  activity: 'activity',
  'living-preference': 'living_hub',
  'renter-toolkit': 'renter_toolkit',
  agent: 'agent',
  'about-us': 'about_us',
};

export const trackUiEvent = (event: UiEvent, source: string, action?: string): void => {
  if (typeof window === 'undefined') return;
  try {
    const route = window.location.pathname.split('/')[1].toLowerCase();
    trackEvent(event, {
      source,
      action,
      page_type: Object.prototype.hasOwnProperty.call(PAGE_TYPES, route) ? PAGE_TYPES[route] : 'other',
    });
  } catch {
    // Analytics must never prevent navigation, opening a form, or displaying an error.
  }
};
